import { formatCurrency, formatDate, formatTime } from '@smarttransit/common'
import { addAlert, isAuthorized, isOnlyInvestor as isOnlyInvestorFn } from '../../../../../utilities/helpers'
import { getAgent, searchAgentGifts } from '../../../../../services/agents-service'

function formatDateTime (date) {
  if (!date) {
    return ''
  }
  return formatDate(date) + ' - ' + formatTime(date)
}

export default {
  name: 'agents-agent-gifts',
  props: {
    signedInUser: Object
  },
  data () {
    return {
      apiInProgress: false,
      currentAgent: null,
      currentAgentError: null,
      countryCurrencies: {},
      gifts: [],
      headers: [
        { text: 'Status', align: 'left', sortable: false, value: 'status' },
        { text: 'Amount', align: 'left', sortable: false, value: 'amount' },
        { text: 'From', align: 'left', sortable: false },
        { text: 'To', align: 'left', sortable: false },
        { text: 'Created', align: 'left', sortable: false, value: 'dateCreated' },
        { text: 'Accepted', align: 'left', sortable: false, value: 'dateAccepted' },
        { text: 'Cancelled', align: 'left', sortable: false, value: 'dateCancelled' }
      ]
    }
  },
  computed: {
    isAdmin () {
      return isAuthorized(this.$props.signedInUser, 'admin')
    },
    isOnlyInvestor () {
      return isOnlyInvestorFn(this.$props.signedInUser)
    },
    agentId () {
      return this.$route.params.agentId
    },
    agentNameLabel () {
      if (!this.currentAgent || !this.currentAgent.stUser) {
        return ''
      }
      return [this.currentAgent.stUser.firstName, this.currentAgent.stUser.lastName].filter(Boolean).join(' ')
    },
    currencyPrefix () {
      if (!this.currentAgent || !this.countryCurrencies) {
        return ''
      }
      const currency = this.countryCurrencies[this.currentAgent.countryId]
      return (currency && currency.currencySymbol) || ''
    }
  },
  watch: {
    '$route.params.agentId' () {
      this.gifts = []
      this.currentAgent = null
      this.currentAgentError = null
      this.loadPage()
    }
  },
  mounted () {
    this.$store.getters.getCountryCurrencies.then((results) => {
      this.countryCurrencies = results || {}
    }).catch((error) => {
      addAlert({ message: error, type: 'error' })
    })
    this.loadPage()
  },
  methods: {
    async loadPage () {
      if (!this.isAdmin || this.isOnlyInvestor) {
        this.currentAgentError = 'The current user does not have permission to view agent gifts'
        return
      }
      try {
        this.apiInProgress = true
        this.currentAgent = await getAgent({ id: this.agentId, includeArchived: true })
        const gifts = await searchAgentGifts({ agentProfileId: this.agentId })
        this.gifts = (gifts || []).map((gift) => {
          return Object.assign({}, gift, {
            amountLabel: formatCurrency(gift.amount, this.currencyPrefix),
            fromLabel: [gift.fromAgentName, gift.fromAgentPhone].filter(Boolean).join(' · '),
            toLabel: [gift.toAgentName, gift.toAgentPhone].filter(Boolean).join(' · '),
            dateCreatedLabel: formatDateTime(gift.dateCreated),
            dateAcceptedLabel: formatDateTime(gift.dateAccepted),
            dateCancelledLabel: formatDateTime(gift.dateCancelled)
          })
        })
      } catch (error) {
        this.currentAgentError = (error && error.message) || 'Could not load agent gifts'
        addAlert({ message: error, type: 'error' })
      } finally {
        this.apiInProgress = false
      }
    }
  }
}
